import { jwtDecode, JwtPayload } from "jwt-decode";
import { useMemo } from "react";

import { AuthStore } from "../store/useAuthStore";
interface IAuthState extends JwtPayload {
  UserInfo: {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    role: string;
    farm: string;
    farmName: string;
  };
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  role: string;
  isAdmin: boolean;
  isSupervisor: boolean;
  status: string;
}

const useAuth = (): IAuthState | null => {
  const { userInfo } = AuthStore();
  const token = userInfo.token;

  const authState = useMemo(() => {
    if (!token) {
      console.warn("No token found in local storage.");

      return null;
    }

    try {
      const decoded = jwtDecode<IAuthState>(token);
      const UserInfo = decoded.UserInfo;

      const isAdmin = UserInfo.role === "admin";
      const isSupervisor = UserInfo.role === "supervisor";
      const status = isAdmin ? "admin" : isSupervisor ? "supervisor" : "farmer";

      return {
        UserInfo,
        ...UserInfo,
        isAdmin,
        isSupervisor,
        status,

        ...(decoded.iat ? { iat: decoded.iat } : {}),
        ...(decoded.exp ? { exp: decoded.exp } : {}),
      };
    } catch (error) {
      console.error("Error decoding token:", error);

      return null;
    }
  }, [token]);

  return authState;
};

export default useAuth;
